import { render } from "./AppThemeToggle.vue?vue&type=template&id=9c7022d4"
import script from "./AppThemeToggle.vue?vue&type=script&lang=js"
export * from "./AppThemeToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__